// WordPress dependencies
import { createRoot, render } from '@wordpress/element';

// Internal dependencies
import CarouselEditPost from './components/carousel/CarouselEditPost';

function App() {
	let PageComponent = null;
	
	if ( document.body.classList.contains( 'post-type-coca_bais_carousel' ) ) {
		PageComponent = CarouselEditPost;
	}

	if ( ! PageComponent ) {
		return null;
	}

	return <PageComponent />;
}

window.addEventListener(
	'load',
	function() {
		const editorRootId = '#coca_bais_carousel__edit_panel_root';
		const rootElement = document.querySelector( editorRootId );
		
		if ( rootElement ) {
			// Render components in React 18+
			if ( typeof createRoot === 'function' ) {
				const root = createRoot( rootElement );
				root.render( <App /> );
			} else {
				// Fallback for React 17
				render( <App />, rootElement );
			}
		}
	},
	false
);
